<template>
  <div>
    <AssignTestCode :state="updateDialog" :data="item" @refresh="refresh" @closeDialog="closeUpdate" />
    <AssignRoomCode :state="roomDialog" :data="item" @refresh="refresh" @closeDialog="closeRoom" />
    <AssignManyDate :state="dateDialog" :data="selectedItems" @refresh="refresh" @closeDialog="closeDate" />
    <AssignDate :state="singleDateDialog" :data="item" @refresh="refresh" @closeDialog="closeSingle" />
    <v-card>
      <div class="pa-6">
        <div class="d-flex justify-end align-center pb-6">
          <v-btn class="mr-6" color="primary" dark outlined @click="exportDataToExcel">
            <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="date" :loading="loading" :disabled="!selected.length">Chỉnh hạn chấm</v-btn>
        </div>
        <v-card outlined>
          <v-data-table
            item-key="id"
            show-select
            v-model="selected"
            :headers="headers"
            :loading="loading"
            :items="students"
            :items-per-page="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :server-items-length="pagination.totalItems"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            :footer-props="{ 'items-per-page-text': 'Số học sinh mỗi trang' }"
            :height="400"
            v-bind="this.$attrs"
            fixed-header
            @pagination="updatePagination"
          >
            <template v-slot:[`footer.page-text`]="items">
              Phòng thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} phòng
            </template>
            <template v-slot:[`item.room`]="{ item }">
              {{ item.room.name || '-' }}
            </template>
            <template v-slot:[`item.subject`]="{ item }">
              {{ item.subject.name || '-' }}
            </template>
            <template v-slot:[`item.studentNumber`]="{ item }">
              {{ item.studentNumber || 0 }}
            </template>
            <template v-slot:[`item.attendedNumber`]="{ item }">
              {{ item.attendedNumber || 0 }}
            </template>
            <template v-slot:[`item.roomCode`]="{ item }">
              {{ item.roomCode || '-' }}
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
              {{ item.endDate | getDate }}
            </template>
            <template v-slot:[`item.testCode`]="{ item }"> {{ item.testCode ? `Từ ${item.testCode}` : '-' }} </template>
            <template v-slot:[`item.action`]="{ item }">
              <div>
                <v-menu open-on-hover bottom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" v-bind="attrs" v-on="on" icon>
                      <v-icon> mdi-pencil </v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item class="cursor-pointer">
                      <v-list-item-title @click="roomUpdate(item)">Chỉnh sửa số túi </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="cursor-pointer">
                      <v-list-item-title @click="update(item)">Chỉnh sửa mã phách</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="cursor-pointer">
                      <v-list-item-title @click="singleDate(item)">Chỉnh sửa hạn chấm thi</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AssignTestCode from './AssignTestCode.vue'
import AssignRoomCode from './AssignRoomCode.vue'
import AssignManyDate from './AssignManyDate.vue'
import moment from 'moment'
import AssignDate from './AssignDate.vue'
import * as XLSX from 'xlsx'
import { ExamMark } from '../../plugins/api'

const originHeaders = [
  {
    text: 'Phòng thi',
    value: 'room',
    align: 'left',
    sortable: false,
    width: '12%'
  },
  {
    text: 'Môn thi',
    value: 'subject',
    align: 'left',
    sortable: false,
    width: '10%'
  },
  {
    text: 'Số lượng học sinh',
    value: 'studentNumber',
    align: 'left',
    sortable: false,
    show: true,
    width: '12%'
  },
  {
    text: 'Số lượng thực thi',
    value: 'attendedNumber',
    align: 'left',
    sortable: false,
    show: true,
    width: '12%'
  },
  {
    text: 'Số túi',
    value: 'roomCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '19%'
  },
  {
    text: 'Mã phách',
    value: 'testCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '17%'
  },
  {
    text: 'Hạn thi',
    value: 'endDate',
    align: 'left',
    sortable: false,
    width: '10%'
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  }
]

export default {
  props: {
    query: Object,
    subjects: Array,
    rooms: Array,
    type: String,
    grade: String
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      dialog: false,
      updateDialog: false,
      roomDialog: false,
      confirmDialog: false,
      dateDialog: false,
      showColumnSelector: false,
      singleDateDialog: false,
      selectedItems: [],
      selected: [],
      students: [],
      item: {},
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      },
      json_fields: {
        'Họ tên': 'name',
        'Mã HS': 'code_short',
        SBD: 'examCode',
        Môn: 'subject',
        'Mã phách': 'testCode',
        'Phòng thi': 'room'
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions('roomSubject', ['fetchRoomSubjects', 'countRoomSubjects']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      try {
        this.pagination.totalItems = await this.countRoomSubjects(this.query)
        this.students = await this.fetchRoomSubjects({
          _start: start,
          _limit: limit,
          ...this.query,
          _sort: 'index:asc'
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    async exportDataToExcel() {
      this.$loading.active = true
      const data = await ExamMark.getMarksData({ exam: this.query.exam })

      const formattedData = this.mapFields(data, this.json_fields)

      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      this.setColumnWidths(worksheet, formattedData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Marks')

      XLSX.writeFile(workbook, `ma_phach.xlsx`)
      this.$loading.active = false
    },
    mapFields(data, fieldMap) {
      return data.map(item => {
        const newItem = {}
        for (const [key, value] of Object.entries(fieldMap)) {
          newItem[key] = item[value]
        }
        return newItem
      })
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })

      worksheet['!cols'] = maxWidths.map((width, index) => {
        if (columnNames[index] === 'id') {
          return { width, hidden: true }
        }
        return { width }
      })
    },
    formatArray(array) {
      const names = array.map(item => item.name)
      return names.join(', ')
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    roomUpdate(item) {
      this.item = item
      this.roomDialog = true
    },
    singleDate(item) {
      this.item = item
      this.singleDateDialog = true
    },
    openConfirm() {
      this.confirmDialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.updateDialog = false
    },
    closeSingle() {
      this.singleDateDialog = false
    },
    closeRoom() {
      this.roomDialog = false
    },
    closeConfirm() {
      this.confirmDialog = false
    },
    date() {
      this.selectedItems = this.selected.map(item => item.id)
      this.dateDialog = true
    },

    closeDate() {
      this.dateDialog = false
    }
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getStatus: item => {
      if (item.status === 'seated') {
        return 'Đã xếp'
      } else if (item.status === 'notSeated') {
        return 'Chưa xếp'
      } else if (item.status === 'seating') {
        return 'Đang xếp'
      } else {
        return '-'
      }
    },
    getDate: item => {
      if (item) return moment(item).format('DD/MM/YYYY')
      return ''
    }
  },
  components: { AssignTestCode, AssignRoomCode, AssignManyDate, AssignDate }
}
</script>
